export default __webpack_public_path__ + "static/media/detail_big_2_3.aa830057.png";